module.exports = __webpack_public_path__ + "static/media/commercial.caf0b2d2.png";